import { RECEIVED_ALL_POLLS } from '../actions';

const defaultState = {
  items: [],
};

export function polls(state = defaultState, action = null) {
  switch (action.type) {
    case RECEIVED_ALL_POLLS: {
      return Object.assign({}, state, { items: action.items });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/polls.js